import React from 'react';
import { useParams } from 'react-router-dom';
import SingleBreadcrumb from './SingleBreadcrumb';
import CogenerationTabs from './CogenerationTabs';


function Cogeneration() {
  const { plantName, id } = useParams(); // Get both plantName and id from the URL

  return (
    <>
      <SingleBreadcrumb plantName={decodeURIComponent(plantName)} />
      <CogenerationTabs id={id} />
    </>
  );
}

export default Cogeneration;
